import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-5 flex h-full w-full flex-col" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "flex h-20 w-full flex-row bg-gray-100" }
const _hoisted_4 = { class: "flex space-x-4" }
const _hoisted_5 = { class: "flex-1 flex-col space-y-1 py-1" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"h-2 rounded bg-slate-700\"></div><div class=\"space-y-3\"><div class=\"grid grid-cols-3 gap-4\"><div class=\"col-span-2 h-2 rounded bg-slate-700\"></div><div class=\"col-span-1 h-2 rounded bg-slate-700\"></div></div><div class=\"h-2 rounded bg-slate-700\"></div></div>", 2)
const _hoisted_8 = [
  _hoisted_6
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-base text-gray-300" }, "Output", -1)
const _hoisted_10 = {
  style: {"white-space":"pre-line"},
  class: "text-gray-50"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editor = _resolveComponent("editor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_editor, {
      language: _ctx.language,
      value: _ctx.value,
      onEdited: _ctx.onEdited
    }, null, 8, ["language", "value", "onEdited"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "disabled my-auto mx-5 h-10 w-16 rounded bg-emerald-500 text-white",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.runCode && _ctx.runCode(...args)))
        }, " Run ")
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["mx-auto w-full bg-slate-800 p-4 shadow", _ctx.fullOutputVisible])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex-1 animate-pulse flex-col space-y-6", _ctx.loadingVisible])
            }, _hoisted_8, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["flex flex-col font-mono", _ctx.outputVisible])
            }, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.Output), 1)
            ], 2)
          ])
        ])
      ], 2)
    ])
  ]))
}